/* eslint-disable linebreak-style */
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from '../../config/axiosInstance';

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HelpIcon from '@material-ui/icons/Help';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import MenuItems from './MenuItem';
import Logo from '../../assets/images/puntu-logo3.svg';
import { fetchEmployer } from '../../store/actions/employer';
import Notification from './Notification';
import ManagerNotificationWrapper from '../ManagerNotificationToggle/layout';
import NotificationFloatingBox from '../NotificationFloatingBox';
import { ChangeAccountModal } from '../ChangeAccountModal';
import animationData from './Animations/Rocket.json';
import Lottie from 'react-lottie';
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from '@material-ui/core';
import warningIcon from '../../assets/images/icons/warningIcon.png'
import { Box } from '@mui/material';
import moment from 'moment';
import 'moment/min/locales';
import WarningBlocking from './Warnings/WarningBlocking';
import WarningBlocked from './Warnings/WarningBlocked';
import WarningFimGratis from './Warnings/WarningFimGratis';
import OfferModal from './Warnings/OfferModal';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WhatsAppButton from './WhatsAppButton';
import PopupWarning from './Warnings/PopupWarning';


const drawerWidth = 270;

const styles = theme => ({
  root: {
    minHeight: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBarFull: {
    // position: 'fixed',
    width: `100%`,
    backgroundColor: theme.palette.primary.contrastText,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBar: {
    // position: 'fixed',
    width: `calc(100% - ${drawerWidth}px)`,
    backgroundColor: theme.palette.primary.contrastText,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${theme.spacing(7)}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.spacing(9)}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: theme.palette.primary.contrastText,
    margin: '0 4px',
    [theme.breakpoints.up('sm')]: {
      margin: '0 12px',
    },
  },
  title: {
    padding: `${theme.spacing(2)}px 0`,
  },
  iconButton: {
    marginLeft: '2%',
    textAlign: 'left',
    display: 'flex',
  },
  drawerPaper: {
    backgroundColor: theme.palette.primary.main,
    height: '100vh',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    position: 'relative',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  toolbar: {
    padding: '0 8px',
    marginBottom: '20px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    textAlign: 'left',
  },
  fullHeight: {
    height: '100%',
  },
  fixedMenuOpen: {
    position: 'fixed',
    overflowY: 'scroll',
    height: '100vh',
    width: drawerWidth,
  },
  fixedMenuClose: {
    position: 'fixed',
    overflowX: 'hidden',
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
  },
  company: {
    margin: '0 1% 0 auto',
    display: 'inline-block',
    alignItems: 'center',
    textAlign: 'left'
  },
  userNameTitle: {
    display: 'inline',
    verticalAlign: 'middle',
    fontWeight: theme.typography.fontWeightStrong,
    marginLeft: '12px',
  },
  logo: {
    marginLeft: theme.spacing(1),
    width: '80px',
  },
  notification: {

    maxWidth: '300px',

  },
  line: {
    color: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgba(0, 0, 0, 0.12)',
    height: 1,
  },
  dateNotification: {
    fontSize: 10,
  },
  headerNotification: {
    padding: 5,
    marginLeft: 2,
    justifyContent: 'center',

  },
  pos: {
    fontSize: 12,
    flexWrap: 'wrap',
  },
  notificationNotRead: {

    backgroundColor: '#537CCD1A',
    maxWidth: '300px',
  },
  notificationDesc: {
    fontSize: 13,
  },
  notificationMessage: {
    padding: 10,
    justifyContent: 'center',
  },
  paper: {
    minWidth: "650px"
  }
});

class Layout extends React.Component {
  state = {
    open: window.innerWidth >= 768,
    width: window.innerWidth,
    anchorEl: null,
    managerNotificationState: 'CLOSED',
    changeProfile: false,
    hasAccess: true,
    modalWelcome: false,
    animationState: { isStopped: false, isPaused: false },
    defaultOptions: {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    },
    expiredDate: '',
    warningLaCasaSinPapel: false
  };



  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.props.onFetchEmployer(this.props.companyCode, this.props.socialName);
    this.searchOpenModal();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  // plansInfo = () => {
  //   axios
  //     .post('/dataSuporte', {
  //       searchTerm: this.props.companyCode,
  //       value: 'Código',
  //     })
  //     .then((response) => {
  //       console.log(response.data[0])
  //       this.setState({ expiredDate: response.data[0].lastRegister })
  //     })
  //     .catch((error) => {
  //       console.error('error', error)
  //     });
  // }

  // searchCoupon() {
  //   axios.get('/company/statusPayment')
  //     .then((result) => {
  //       this.setState({ hasAccess: result.data.hasAccess })
  //       if (result.data.hasAccess == false) {
  //         this.checkUrl();
  //       }
  //     })
  //     .catch(error => console.log('error', error));
  // };

  // checkUrl = () => {
  //   let params = window.location
  //   if (params.pathname != '/assinatura') {
  //     window.location.href = `/assinatura`;
  //   }
  //   if (params.pathname == '/assinatura') {
  //     this.setState({ modalWelcome: true })
  //   }
  // }

  companies = JSON.parse(localStorage.getItem('companies'));

  // eslint-disable-next-line consistent-return
  notRead = (item) => {
    if (item.dtRead) {
      return item;
    }
  }


  resizeHandler = () => {
    this.setState((prevState) => {
      if (prevState.open && prevState.width >= 768 && window.innerWidth < 768) {
        return { open: false, width: window.innerWidth };
      }
      if (!prevState.open && prevState.width < 768 && window.innerWidth >= 768) {
        return { open: true, width: window.innerWidth };
      }
      return { width: window.innerWidth };
    });
  };


  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleSwitchProfile = () => {
    this.setState({ changeProfile: true, anchorEl: null });
  }

  handleWhatsAppClick = () => {
    // Redirecione para o WhatsApp Web
    window.location.href = 'https://api.whatsapp.com/send/?phone=5561996894936&text&type=phone_number&app_absent=0';
  };


  searchOpenModal = () => {
    axios.get('/warning')
      .then((result) => {
        if (!result.data.isTenDaysToExpiration && !result.data.isBloquedAccount) {
          this.setState({ warningLaCasaSinPapel: true })
        }
      })
      .catch(error => console.log('error', error));
  };

  handleCloseLaCasa = () => {
    this.setState({ warningLaCasaSinPapel: false })
  }

  render() {
    const {
      classes, children, socialName, companyCode, userName,
    } = this.props;
    const {
      open, anchorEl, managerNotificationState, hasAccess
    } = this.state;

    return (
      <>
        {/* {
          this.state.warningLaCasaSinPapel ?
            <LaCasaSinPapelWarning open={this.state.warningLaCasaSinPapel} handleCloseLaCasa={this.handleCloseLaCasa} />
            // <LaCasaSinPapelWarningPointDuplicated open={this.state.warningLaCasaSinPapel}/>
            :
            <WarningBlocking />
        } */}
        <PopupWarning />
        <WarningBlocking />
        <WarningBlocked />

        {/* <OfferModal /> */}


        {/* <WarningFimGratis /> */}

        <div className={classes.root}>
          <AppBar
            position="absolute"
            className={classNames(hasAccess ? classes.appBar : classes.appBarFull, !open && classes.appBarShift)}
          >
            <Toolbar disableGutters>
              <div className={classes.iconButton}>

                <ManagerNotificationWrapper
                  state={managerNotificationState}
                  items={[
                    {
                      text: 'Retornamos nossas atividades na próxima semana. Não esqueçam de trazer a documentação.',
                      author: 'Lucas Moreira',
                      viewsDetails: '5/12',
                      creationDate: '10/04',
                    },
                  ]}
                  onCreateNewNotification={() => this.setState({ managerNotificationState: 'CREATE_NOTIFICATION' })}
                  onOpenList={() => {
                    if (managerNotificationState === 'OPEN_LIST') {
                      this.setState({ managerNotificationState: 'CLOSED' });
                    } else {
                      this.setState({ managerNotificationState: 'OPEN_LIST' });
                    }
                  }}
                />
                <WhatsAppButton />
                <Notification />
                <IconButton
                  href="https://support.puntu.digital/"
                  color="primary"
                  target="_blank"
                >
                  <HelpIcon />
                </IconButton>
                <div
                  style={{
                    // position: 'absolute',
                    bottom: '15%',
                    right: '78%',
                    zIndex: 9999,
                  }}
                >
                  <IconButton
                    color="primary"
                    aria-label="WhatsApp"
                    onClick={this.handleWhatsAppClick}
                  >
                    <WhatsAppIcon style={{ fontSize: '27px', color: '#537ccd' }} />
                  </IconButton>
                </div>
              </div>

              <div className={classes.company}>
                <Typography variant="h6" color="primary" align="right">
                  {socialName}
                </Typography>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  align="left"
                  className={classes.userNameTitle}
                >
                  {userName}
                </Typography>
                <IconButton onClick={this.handleClick}>
                  <ExpandMore />
                </IconButton>
                <Typography variant="caption" color="textSecondary">Código Empregador: {companyCode}</Typography>
              </div>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.handleClose}>
                  <Link className={classes.link} to="/logout">
                    Sair
                  </Link>
                </MenuItem>

                {(this.companies && this.companies.length > 1)
                  ? (
                    <MenuItem onClick={this.handleSwitchProfile}>
                      Trocar Empresa
                    </MenuItem>
                  )
                  : null
                }
              </Menu>
            </Toolbar>
          </AppBar>

          {hasAccess ?
            <Drawer
              variant="permanent"
              classes={{
                paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
              }}
              open={this.state.open}
              PaperProps={{ classes: { root: classes.fullHeight } }}
            >
              <div className={open ? classes.fixedMenuOpen : classes.fixedMenuClose}>
                <Grid container alignItems="center" wrap="nowrap" className={classes.title}>
                  <Grid item>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={open ? this.handleDrawerClose : this.handleDrawerOpen}
                      className={classes.menuButton}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Link to="/">
                      <img src={Logo} alt="Puntu" className={classes.logo} />
                    </Link>
                  </Grid>
                </Grid>
                <MenuItems open={open} handleOpen={this.handleDrawerOpen} />
              </div>
            </Drawer>
            : ""}

          <Dialog
            open={this.state.modalWelcome}
            onClose={() => this.setState({ modalWelcome: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: classes.paper }}
          >
            <Grid
              style={{
                width: '100px',
                height: '100px',
                alignSelf: 'center',
                marginTop: '35px',
                marginBottom: '-8px'
              }}
            >
              <Lottie
                options={this.state.defaultOptions}
                width={130}
                height={130}
                isStopped={this.state.animationState.isStopped}
                isPaused={this.state.animationState.isPaused}
              />
            </Grid>
            <Grid style={{ padding: '-1px 20px' }}>
              <DialogTitle id="alert-dialog-title">
              </DialogTitle>
              <Typography
                style={{ color: '#3978D3', fontWeight: 'bold', fontSize: '40px', textAlign: 'center', fontFamily: "sans-serif" }}>
                Você está quase lá!
              </Typography>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
                  <Typography style={{ color: '#000000d6' }}>
                    Cadastre sua forma de pagamento para iniciar o teste grátis de 30 dias.
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogTitle id="alert-dialog-title" style={{ paddingTop: 0, display: 'flex', justifyContent: 'center' }}>
                <Button
                  onClick={() => this.setState({ modalWelcome: false })}
                  style={{ padding: '20px', borderRadius: '10px', fontWeight: 'bold', color: '#FFFF', fontSize: 20, backgroundColor: '#537ccd' }}>
                  Cadastre e comece já!
                </Button>
              </DialogTitle>
              <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center', paddingTop: 10, paddingBottom: 55 }}>
                <Grid style={{ display: 'flex', justifyContent: 'center' }}>
                  <img style={{ width: "24px", height: "21px" }} src={warningIcon} alt={"icone de alerta."} />
                  <Typography style={{ color: '#000000d6' }}>
                    Não se preocupe, você poderá cancelar a assinatura a
                  </Typography>
                </Grid>
                <Typography style={{ color: '#000000d6' }}>
                  qualquer momento dentro do período de teste sem custo algum.
                </Typography>
              </DialogContentText>
            </Grid>
          </Dialog>

          <main className={classes.content}>
            <div className={classes.toolbar} />
            {children}
          </main>

          <div
            style={{
              position: 'fixed',
              zIndex: '999999',
              bottom: 0,
              width: '100%',
            }}
          >
            {managerNotificationState === 'CREATE_NOTIFICATION' && (
              <NotificationFloatingBox onClose={() => this.setState({ managerNotificationState: 'CLOSED' })} />
            )}
          </div>
          <ChangeAccountModal
            open={this.state.changeProfile}
            handleClose={() => this.setState({ changeProfile: false })}
          />
        </div >
      </>
    );
  }
}

const mapStateToProps = state => ({
  socialName: state.data.data.socialName,
  companyCode: state.auth.companyCode,
  userName: state.auth.userName,

});

const mapDispatchToProps = dispatch => ({
  onFetchEmployer: (companyCode, socialName) => dispatch(fetchEmployer(companyCode, socialName)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Layout));
